<template>
  <div>
    <ul
      v-if="surveyContents[selectedCategory]"
      class="survey"
    >
      <li
        v-for="survey in surveyContents[selectedCategory].questions"
        :key="survey.id"
      >
        <p><i>Q</i> {{ survey.question }}</p>
        <div class="form_group-element">
          <span class="form_element-radio">
            <input
              :id="survey.id"
              v-model="survey.checked"
              type="radio"
              :name="survey.id"
              :value="true"
              @change="checkYes()"
            >
            <label
              :for="survey.id"
              class="focus"
            >예</label>
          </span>
          <span class="form_element-radio">
            <input
              :id="survey.id + '1'"
              v-model="survey.checked"
              type="radio"
              :name="survey.id"
              :value="false"
              @change="checkYes()"
            >
            <label
              :for="survey.id + '1'"
              class="focus"
            >아니오</label>
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

// const INITIAL_UNCHECKED_BTN_CNT = 5;
const INITIAL_POSITIVE_CHECK_CNT = -1;

export default {
  name: 'SurveySurveyContents',
  props: {
    selectedCategory: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },

  },
  data() {
    return {

    };
  },
  computed: {
    isAllSelected() {
      const selectedContents = this.surveyContents[this.selectedCategory];
      return selectedContents ? selectedContents.uncheckedBtnCnt === 0 : false;
    },
    ...mapGetters({
      surveyContentsFetched: 'survey/surveyContentsFetched',
      surveyContents: 'survey/surveyContents',
    }),
  },
  watch: {
    isAllSelected(newVal) {
      this.$emit('input', newVal);
    },
    selectedCategory() {
      this.initCategoryData();
    },
    surveyContentsFetched() {
      if (this.surveyContentsFetched) this.fetchSurveyContents();
    },
  },

  methods: {
    fetchSurveyContents() {
      this.surveyContentsStore = this.surveyContents;
    },
    initCategoryData() {
      // this.uncheckedBtnCnt = INITIAL_UNCHECKED_BTN_CNT;

      Object.values(this.surveyContents).forEach(
        (n) => {
          // eslint-disable-next-line no-param-reassign
          n.uncheckedBtnCnt = n.questions.length;
          // eslint-disable-next-line no-param-reassign
          n.questions.forEach((x) => { x.checked = null; });
        },
      );

      this.$emit('positive-check-count-changed', INITIAL_POSITIVE_CHECK_CNT);
    },
    checkYes() {
      const contents = this.surveyContents[this.selectedCategory];
      const { questions } = contents;
      const cnt = questions.reduce((acc, n) => {
        if (n.checked === null) {
          return acc + 1;
        }
        return acc;
      }, 0);
      contents.uncheckedBtnCnt = cnt;

      const cntTrue = questions.reduce((acc, n) => {
        if (n.checked === true) {
          return acc + 1;
        }
        return acc;
      }, 0);

      this.$emit('positive-check-count-changed', cntTrue);
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/views/survey/main/partial/SurveySurveyContents.vue